<script setup lang="ts">
import BaseLayout from "./base.vue";
</script>

<template>
  <base-layout>
    <template #mainContent>
      <main class="flex justify-center items-center flex-col overflow-auto flex-fill-height">
        <slot />
      </main>
    </template>
  </base-layout>
</template>
